// src/pages/ApartmentDetail.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { categories } from "../component/ApartmentsOverviewWithImages";
import { FaUser, FaCalendarAlt, FaUsers } from "react-icons/fa";
import AmenitiesSection from "../component/AmenitiesSection";
import TestimonialsSection from "../component/TestimonialsSection";
import LocationSection from "../component/LocationSection";

const ApartmentDetail = () => {
  const { id } = useParams();
  const apartmentId = parseInt(id);
  const apartment = categories.find((item) => item.id === apartmentId);

  const [activeImage, setActiveImage] = useState(
    apartment ? apartment.images[0] : ""
  );

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    checkIn: "",
    checkOut: "",
    guests: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `
Apartment Booking Request

Apartment: ${apartment.name}
Name: ${formData.name}
Email: ${formData.email}
Check In: ${formData.checkIn}
Check Out: ${formData.checkOut}
Guests: ${formData.guests}
  `;

    const whatsappNumber = "923034935404";

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    // 👉 WhatsApp open
    window.open(whatsappUrl, "_blank");

    // ✅ 👉 GOOGLE CONVERSION TRACKING (IMPORTANT)
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-18044656656/ojOzCO_arZIcEJC4rpxD'
        });
      }
    }, 300);
  };

  if (!apartment) {
    return (
      <div className="py-12 text-center text-2xl font-semibold">
        Apartment not found
      </div>
    );
  }

  return (
    <>
      <section className="w-full">
        {/* HERO SECTION */}
        <div
          className="relative h-screen w-full backgroundattachment bg-cover flex items-center justify-center"
          style={{
            backgroundImage: `url(${apartment.images[0]})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% 50%",
          }}
        >
          <div className="absolute inset-0  lg:bg-black/35 bg-black/50"></div>

          <div className="relative text-center">
            <h1 className="text-white text-5xl md:text-[66px] 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
              {apartment.name}
            </h1>
            <p className="text-xl md:text-2xl mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">{apartment.description}</p>
            {/* <p className="text-2xl font-bold text-[#c9a86c]">{apartment.price}</p> */}
          </div>
        </div>

        {/* CONTENT SECTION */}
        <div className="container-custom py-12 grid grid-cols-1 lg:grid-cols-2 md:gap-16 gap-8">

          {/* LEFT: BOOKING FORM */}
          <div className="rounded-2xl p-6 bg-white shadow-lg hover:shadow-xl">
            <h2 className="text-2xl font-bold mb-6 text-[#1a2b3c]">
              Book This Apartment
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">

              {/* Apartment Name */}
              <div>
                <label className="block text-gray-700 mb-1">Apartment</label>
                <input
                  type="text"
                  value={apartment.name}
                  readOnly
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100"
                />
              </div>

              {/* Price */}
              {/* <div>
                <label className="block text-gray-700 mb-1">Price Per Night</label>
                <input
                  type="text"
                  value={apartment.price}
                  readOnly
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100"
                />
              </div> */}

              {/* Name */}
              <div>
                <label className="block text-gray-700 mb-1">Full Name</label>
                <div className="flex items-center gap-2 border border-gray-300 rounded-lg px-3">
                  <FaUser className="text-gray-400" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    className="w-full py-2 outline-none"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="block text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
                  required
                />
              </div>

              {/* Dates */}
              <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                <div>
                  <label className="block text-gray-700 mb-1">Check-in</label>
                  <div className="flex items-center gap-2 border border-gray-300 rounded-lg px-3">
                    <FaCalendarAlt className="text-gray-400" />
                    <input
                      type="date"
                      name="checkIn"
                      value={formData.checkIn}
                      onChange={handleChange}
                      className="w-full py-2 outline-none"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 mb-1">Check-out</label>
                  <div className="flex items-center gap-2 border border-gray-300 rounded-lg px-3">
                    <FaCalendarAlt className="text-gray-400" />
                    <input
                      type="date"
                      name="checkOut"
                      value={formData.checkOut}
                      onChange={handleChange}
                      className="w-full py-2 outline-none"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Guests */}
              <div>
                <label className="block text-gray-700 mb-1">Guests</label>
                <select
                  name="guests"
                  value={formData.guests}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                  <option value="5">5 Guests</option>
                  <option value="6">6 Guests</option>
                </select>
              </div>

              <button
                type="submit"
                className="w-full bg-[#c9a86c] text-white py-3 rounded-full font-semibold hover:bg-[#b38f5a] transition-all duration-300"
              >
                Book via WhatsApp
              </button>

            </form>
          </div>

          {/* RIGHT: IMAGE GALLERY */}
          <div className="space-y-4" id="currentapartmentdetail">

            {/* MAIN IMAGE */}
            <img
              src={activeImage}
              alt="Apartment"
              className="w-full h-[400px] object-cover rounded-xl shadow-lg transition-all duration-500"
            />

            {/* THUMBNAILS */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {apartment.images.map((img, index) => (
                <a href="#currentapartmentdetail">
                  <img
                    key={index}
                    src={img}
                    alt="thumb"
                    onClick={() => setActiveImage(img)}
                    className={`h-24 w-full object-cover rounded cursor-pointer transition ${activeImage === img
                      ? "ring-2 ring-[#c9a86c]"
                      : "opacity-80 hover:opacity-100"
                      }`}

                  />
                </a>
              ))}
            </div>

          </div>
        </div>
      </section>
      <AmenitiesSection />
      <TestimonialsSection />
      <LocationSection />

    </>
  );
};

export default ApartmentDetail;